import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { PublicPlaylist } from "@classview/shared-types";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

import { AddPlaylistFormData } from "../types/add-playlist-schema";

const createPlaylist = async ({
  orgId,
  data,
}: {
  orgId: string;
  data: AddPlaylistFormData;
}): Promise<PublicPlaylist> => {
  const response = await axiosClient.post(`${orgId}/playlists`, data);
  return response.data;
};

export function useCreatePlaylist(
  mutationOptions?: UseMutationOptions<
    PublicPlaylist,
    HttpError,
    { orgId: string; data: AddPlaylistFormData }
  >,
) {
  return useMutation({
    mutationFn: createPlaylist,
    ...mutationOptions,
  });
}
